import adHocPurchases from '@/store/ad-hoc-purchases'
import affiliate from '@/store/affiliate'
import app from '@/store/app'
import budgets from '@/store/budgets'
import categories from '@/store/categories'
import directPurchases from '@/store/direct-purchases'
import documents from '@/store/documents'
import finances from '@/store/finances'
import marketplace from '@/store/marketplace'
import profile from '@/store/profile'
import purchases from '@/store/purchases'
import statistics from '@/store/statistics'
import storekeeper from '@/store/storekeeper'
import suppliers from '@/store/suppliers'
import ui from '@/store/ui'
import user from '@/store/user'
import userManagement from '@/store/user-management'
import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    appConfig: appConfigStoreModule,
    affiliate,
    app,
    user,
    userManagement,
    categories,
    suppliers,
    purchases,
    statistics,
    ui,
    budgets,
    profile,
    documents,
    marketplace,
    storekeeper,
    finances,
    adHocPurchases,
    directPurchases,
  },

  actions: {
    resetState({ commit }) {
      commit('user/resetState')
      commit('userManagement/resetState')
      commit('categories/resetState')
      commit('suppliers/resetState')
      commit('purchases/resetState')
      commit('purchases/purchaseConfirmation/resetState')
      commit('statistics/resetState')
      commit('ui/resetState')
      commit('budgets/resetState')
      commit('profile/resetState')
      commit('documents/resetState')
      commit('marketplace/auth/resetState')
      commit('storekeeper/resetState')
      commit('finances/resetState')
      commit('adHocPurchases/resetState')
      commit('directPurchases/resetState');
    },
  },
})
